import { useHistoricQuotes } from "@rentablo/api/apiv1";
import type { DateValuePair } from "@rentablo/api/apiv1";

export const useHistoricQuotesPerYear = (
  investmentId?: number,
  tickerSymbol?: string,
  from?: string,
  { enabled = true }: { enabled?: boolean } = { enabled: true }
) => {
  const query = useHistoricQuotes(
    {
      investmentId: investmentId ? [investmentId] : [],
      tickerSymbol: tickerSymbol ? [tickerSymbol] : [],
      from,
      intervalPosition: "last",
      interval: "year",
    },
    {
      enabled: !!investmentId && !!tickerSymbol && enabled,
    }
  );

  return {
    ...query,
    data: query.data?.historicQuotes?.[tickerSymbol!] as
      | DateValuePair[]
      | undefined,
  };
};

export const useHistoricQuotesPercent = (
  investmentId?: number,
  tickerSymbol?: string,
  from?: string
) => {
  const query = useHistoricQuotes(
    {
      investmentId: investmentId ? [investmentId] : [],
      tickerSymbol: tickerSymbol ? [tickerSymbol] : [],
      from,
      inPercentFrom: "currentToNow",
      intervalPosition: "current",
      interval: "year",
    },
    {
      enabled: !!investmentId && !!tickerSymbol,
    }
  );

  return {
    ...query,
    data: query.data?.historicQuotes?.[tickerSymbol!] as
      | DateValuePair[]
      | undefined,
  };
};
